import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useParams } from 'quartz-routing/react-router';
import { GET_COLLECTION_BY_SLUG_QUERY as PUBLIC_GET_COLLECTION_BY_SLUG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc-external.dfc.new';
import { GET_COLLECTION_BY_SLUG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc.dfc.new';
import { Filter } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { LISTINGS_PER_PAGE } from '../../constants/searchResults';
import { useAppliedFilters } from '../../filters/hooks/useAppliedFilters';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { SORT_OPTIONS } from '../components/SortDropdown';
import { mapAppliedFiltersForRpc, mapSortForRpc } from '../utils/searchMappers';

const SEARCH_TIMEOUT_MS = 10000;

export function useGetCollectionBySlugQuery({ skip }: { skip?: boolean } = {}) {
  const { collectionSlug } = useParams<{ collectionSlug?: string }>();
  const offset = useOffset();
  const sorts = useSorts();
  const filter = useDSCollectionFilter();

  return useAppContextQuery({
    app: GET_COLLECTION_BY_SLUG_QUERY,
    public: PUBLIC_GET_COLLECTION_BY_SLUG_QUERY,
    options: {
      context: { timeout: SEARCH_TIMEOUT_MS },
      skip: skip || !collectionSlug,
      variables: {
        slug: collectionSlug ?? '',
        offset,
        limit: LISTINGS_PER_PAGE,
        filter,
        sorts: sorts ?? [],
      },
    },
  });
}

function useDSCollectionFilter(): Filter | undefined {
  const appliedFilters = useAppliedFilters();
  const facetFilters = appliedFilters.filter(
    (filter) => filter.field !== 'PRODUCT_TYPE'
  );
  if (facetFilters.length === 0) return undefined;
  return mapAppliedFiltersForRpc(facetFilters);
}

function useOffset() {
  const params = useSearchParams();
  const page = Number(params.get('page')) || 1;
  return (page - 1) * LISTINGS_PER_PAGE;
}

function useSorts() {
  const params = useSearchParams();
  const sort = params.get('sort', { allowedValues: Object.keys(SORT_OPTIONS) });
  return mapSortForRpc(sort);
}
